import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import { ScrollableList } from "./StatementScreenStyles";

export default ({ members, handleToggle, checked }) => {
  return (
    <ScrollableList>
      {members.map((value) => {

        return (
          <ListItem
            key={value.id}
            role={undefined}
            button
            onClick={handleToggle(value)}
          >
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={checked.indexOf(value) !== -1}
                tabIndex={-1}
                disableRipple
              />
            </ListItemIcon>
            <ListItemText
              id={value.id}
              primary={
                value.membershipId + ". " + value.name + " " + value.surname
              }
            />
          </ListItem>
        );
      })}
    </ScrollableList>
  );
};
